module.exports = {"652201001":"东河区街道","652201002":"西河区街道","652201003":"新市区街道","652201004":"丽园街道","652201005":"石油新城街道","652201100":"雅满苏镇","652201101":"七角井镇","652201102":"星星峡镇","652201103":"二堡镇","652201104":"陶家宫镇","652201105":"五堡镇","652201200":"沁城乡","652201201":"乌拉台哈萨克民族乡","652201202":"双井子乡","652201203":"大泉湾乡","652201205":"回城乡","652201206":"花园乡","652201207":"南湖乡","652201209":"德外里都如克哈萨克乡","652201210":"西山乡","652201211":"天山乡","652201212":"白石头乡","652201214":"柳树沟乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652201.json
// module id = 3209
// module chunks = 0